'use client';

import cn from 'classnames';

import { useHeaderPosition } from '@/hooks/useHeaderPosition';

import s from './Achievements.module.scss';

const MockAchievements = [
  {
    title: '№1 на рынке искусственного интеллекта',
    subtitle: 'CNews Analytics, 2023',
    image: 'https://cdn.cloud.ru/backend/career/news/news-1.png',
  },
  {
    title: '№1 по темпам роста IaaS-сервисов',
    subtitle: 'Data Center Awards 2023',
    image: 'https://cdn.cloud.ru/backend/career/news/news-2.png',
  },
  {
    title: '№1 по PaaS-сервисам',
    subtitle: 'iKS-Consulting, 2022',
    image: 'https://cdn.cloud.ru/backend/career/news/news-3.png',
  },
  {
    title: '№1 в рейтинге лучших работодателей в сфере облачных услуг',
    subtitle: 'Telecom Daily, 2023',
    image: 'https://cdn.cloud.ru/backend/career/news/news-4.png',
  },
  {
    title:
      'Суперкомпьютеры Christofari и Christofari Neo в топ–500 самых мощных суперкомпьютеров мира',
    image: 'https://cdn.cloud.ru/backend/career/news/news-5.png',
  },
];

const Achievements = ({ className = '' }: { className?: string }) => {
  const { showHeader } = useHeaderPosition();

  return (
    <section className={cn(s.root, className)}>
      {MockAchievements.map(({ title, subtitle, image }, index) => {
        return (
          <div
            className={cn(s.news, 'link', { [s.withHeader]: !!showHeader })}
            key={index}
          >
            <img className={s.image} src={image} alt="shapes" />
            <div className={s.content}>
              <h2 className={s.title}>{title}</h2>
              <h3 className={s.subtitle}>{subtitle}</h3>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export { Achievements };
